export default __webpack_public_path__ + "static/media/allmand.2ad3de50.pdf";